const getDefaultState = () => ({
  mesReporte: {
    seleccionado: 'Este Mes',
    lista: []
  },

  opciones: {
    searchString: '',
    rangoFechas: '',
    rango: false,
    start: '',
    end: '',
    banco: null,
    generado: false,
    filtro: {
      limiteDiasCobrar: null,
      cantidadFacturasPendientes: null,
      codigoMoneda: { id: '' },
      receptor: { id: '' },
      user: { id: '' },
      ubicacion: {
        provincia: { id: '' },
        canton: { id: '' }
      },
      documento: { id: '' },
      banco: { id: '' }
    }
  },

  mesReporteCompras: {
    seleccionado: 'Este Mes',
    lista: []
  },

  opcionesCompras: {
    searchString: '',
    rangoFechas: '',
    rango: false,
    start: '',
    end: '',
    banco: null,
    generado: false,
    filtro: {
      codigoMoneda: { id: '' },
      receptor: { id: '' },
      emisor: { id: '' }, // proveedor de compras
      user: { id: '' },
      ubicacion: {
        provincia: { id: '' },
        canton: { id: '' }
      },
      documento: { id: '' },
      banco: { id: '' }
    }
  }
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState())
}

export const actions = {}
